import type { QueryStatus } from '@tanstack/react-query';

import useAccountRouter from 'Components/Account/useAccountRouter';
import { useAccountPermitsChecker } from 'Controllers/AccountPermitsChecker/AccountPermitsChecker.helpers';
import { triggerAccountPageResetFiltersEvent } from 'Services/analytics/events';
import { AccountDateRange, AccountDelivered, AccountSlugs } from 'Types/account';
import { PurchasesCompleteStatusTypes } from 'Types/purchaseCompleteStatus';
import { QueryCoreStatus } from 'Types/queryCoreStatus';

export interface UseAccountResetFiltersReturnType {
	resetFilters: () => void;
	showFilterReset: boolean;
}

const useAccountResetFilters = ({ queryStatus }: { queryStatus?: QueryStatus }): UseAccountResetFiltersReturnType => {
	const { changePage, dateRangeType, hideDelivered, purchasesCompleteStatusType, slug } = useAccountRouter();

	const permits = useAccountPermitsChecker();
	const shouldDisplayDateRangeFilter = permits?.displayDataRangeFilter?.();

	const isLoading = queryStatus === QueryCoreStatus.Loading;

	const defaultDateRange = AccountDateRange.ALL;
	const defaultPurchasesCompleteStatusType = PurchasesCompleteStatusTypes.All;

	const showFilterReset =
		hideDelivered ||
		(shouldDisplayDateRangeFilter &&
			((dateRangeType && dateRangeType !== defaultDateRange) ||
				(slug === AccountSlugs.COMPLETE &&
					purchasesCompleteStatusType &&
					purchasesCompleteStatusType !== defaultPurchasesCompleteStatusType)) &&
			!isLoading);

	const resetFilters = () => {
		changePage({
			dateRangeType: defaultDateRange,
			hideDelivered: AccountDelivered.SHOW,
			purchasesCompleteStatusType: defaultPurchasesCompleteStatusType,
		});

		triggerAccountPageResetFiltersEvent(slug);
	};

	return { resetFilters, showFilterReset };
};

export default useAccountResetFilters;
